export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-thumbnail-960-248d9e07b7a249d44b422567089a127c.webp";